/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Loads sender company profile data from an appointment for ViewAppointments navigation.
 * @module logic/appointments/loadAppointmentSenderCompany
 */

import { getAppointmentDetail } from "../appointment/index.js";

/**
 * @param {Object} options
 * @param {import("react-router").NavigateFunction} options.navigate
 * @param {string} options.appointmentId
 * @param {string} options.eventId
 * @returns {Promise<Object|null>} Sender company or null when unavailable
 */
export const loadAppointmentSenderCompany = async ({
  navigate,
  appointmentId,
  eventId,
}) => {
  const detail = await getAppointmentDetail(navigate, appointmentId, eventId);
  return detail?.senderCompany || null;
};
